<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <div class="btn-box">
          <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin: 0 5px;">加班日期</span>
          <el-date-picker v-model="timeValue" size="small" type="daterange" style="width: 280px;"
                          :picker-options="pickerOptions" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          align="right" value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <button-add :pathName="addDataParkHonor" v-if="permissionCodes.indexOf('034013001') !== -1" style="margin-left: 10px;"/>
        <button-cancel value="查看可调休天数" @cancel="showDialogVisible" />
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
      <input-search placeholder="申请人姓名" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该请假调休？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />

    <el-dialog title="可调休天数" :visible.sync="dialogVisible" width="80%" >
      <div class="search-line" style="margin-top: 0">
        <div></div>
        <input-search placeholder="人员姓名/所属部门" @search="searchKey2" />
      </div>
      <table-main :tableHeight="500" :selection="false" :hasOperation="false" :tableHead="tableHead2" :tableData="tableData2" :total="total2" :pageNum="requestData2.pageNum" :pageSize="requestData2.pageSize" @changePagination="changePagination2" />
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/AttendancePoint'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import ButtonCancel from "../../../components/Button/ButtonCancel";

  export default {
    components: {
      ButtonCancel,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb
    },
    name: 'attendance-adjust-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '请假调休'
        }],
        addDataParkHonor: 'attendance-adjust-add',
        operationArr: ['modify', 'delete'],
        timeValue: [],
        pickerOptions: {
          shortcuts: [{
            text: '近一年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '近三年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365 * 3)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '近五年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(end.getTime() - 3600 * 1000 * 24 * 365 * 5)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        tableHead: [{
          prop: 'personName',
          label: '申请人姓名'
        }, {
          prop: 'date',
          label: '请假调休日期'
        }, {
          prop: 'optionsText',
          label: '请假调休时段'
        }, {
          prop: 'typeText',
          label: '类型'
        }, {
          prop: 'statusText',
          label: '状态'
        }, {
          prop: 'memo',
          label: '备注'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        requestData: {
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
          startTime: '',
          endTime: ''
        },

        dialogVisible: false,
        total2: 0,
        tableHead2: [{
          prop: 'personName',
          label: '人员姓名'
        }, {
          prop: 'deptName',
          label: '所属部门'
        }, {
          prop: 'positionName',
          label: '所在岗位'
        }, {
          prop: 'days',
          label: '可调休天数(天)'
        }],
        tableData2: [],
        requestData2: {
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getCreatTime()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getCreatTime() {
        let nowDate = new Date();
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
        let date = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
        this.timeValue[0] = `${year}-${month}-${date}`
        this.timeValue[1] = `${year}-${month}-${date}`
        this.getPage();
      },
      getPage () {
        if (this.timeValue) {
          this.requestData.startTime = this.timeValue[0] || ''
          this.requestData.endTime = this.timeValue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        this.$axios.post(api.getAttendanceAdjustPage, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.status === '1') {
                  v.statusText = '保存'
                } else if (v.status === '2') {
                  v.statusText = '审批中'
                } else if (v.status === '3') {
                  v.statusText = '通过'
                } else if (v.status === '4') {
                  v.statusText = '驳回'
                }
                if (v.type === '3') {
                  v.typeText = '请假'
                } else if (v.type === '4') {
                  v.typeText = '调休'
                }
                if (v.options === '1') {
                  v.optionsText = '上午'
                } else if (v.options === '2') {
                  v.optionsText = '下午'
                } else if (v.options === '3') {
                  v.optionsText = '整天'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        let rowData = {}
        this.tableData.map(v => {
          if (v.code === code) {
            rowData = v
          }
        })
        if (rowData.status === '3') {
          nError('审批已通过 无法修改')
          return false
        }
        this.$router.push({
          path: '/attendance_adjust_modify/' + code
        })
      },

      deleteLine (code) {
        let rowData = {}
        this.tableData.map(v => {
          if (v.code === code[0]) {
            rowData = v
          }
        })
        if (rowData.status === '3') {
          nError('审批已通过 无法删除')
          return false
        }
        this.$axios.post(api.deleteAttendanceAdjustByCodes, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      },

      showDialogVisible () {
        this.getAttendanceAdjustRestDays()
        this.dialogVisible = true
      },

      searchKey2 (v) {
        this.requestData2.pageNum = 1
        this.requestData2.searchKey = v
        this.getAttendanceAdjustRestDays()
      },

      changePagination2 (data) {
        this.requestData2.pageNum = data[0]
        this.requestData2.pageSize = data[1]
        this.getAttendanceAdjustRestDays()
      },

      getAttendanceAdjustRestDays () {
        this.$axios.post(api.getAttendanceAdjustRestDays, this.requestData2)
          .then(res => {
            let data = res.data.data.list
            this.total2 = res.data.data.total
            this.tableData2 = data
          })
          .catch(errorHandler('获取数据失败'))
      }
    },
    watch: {
      timeValue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .form-line {
    width: 420px;
    margin: 20px auto;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .red {
    color: red;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceAdjust/AttendanceAdjustManage.vue